module.exports = __webpack_public_path__ + "pc/img/career-developer.d90b2f99.webp";